var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sign-in"},[_c('div',{staticClass:"logo"}),_c('vnt-button',{attrs:{"click":_vm.login}},[_vm._v("Sign In")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }